module.exports = __webpack_public_path__ + "static/media/handbook.83c2056e.svg";